import React, { useState, useEffect, useContext } from 'react';
import Starter from "../../../../Assets/Images/Starter.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import PolarAreaChart from "../../../PolarAreaChart/PolarAreaChart";
import { useGroupReportDate } from '../../../../Context/GroupReportDate';
import StarterChart360 from './StarterChart360';
import GroupReportContext from '../../../../Context/GroupReportContext';

import HeartIcon from "../../../../Assets/Images/Heart-Icon.png";
import StrengthIcon from '../../../../Assets/Images/STRENGTH.png';
import SoulIcon from '../../../../Assets/Images/SOUL.png';
import MindIcon from '../../../../Assets/Images/MIND.png'
import { initialData } from '../groupReport-pdf/QuadrantInFocus';
import { applyFullTieOrder, isFullTie } from '../../../../utils/quadrantTieOrder';

export default function StarterQuardrant360({ apiData, reportType, pageNumber }) {
  const groupReportCtx = useContext(GroupReportContext)
  const { averagePercentages, averagePercentagesSelf } = groupReportCtx;

  const [highestStarter, setHighestStarter] = useState('')
  const [snapshotResult, setSnapshotResults] = useState([])
  const [snapshotResultSelf, setSnapshotResultsSelf] = useState([])
  const [variablsMapArray, setVariableMapArray] = useState()
  const [starterLabel, setStarterLabel] = useState([])
  const [highestScoredVariable, setHighestScoredVariable] = useState('')

  const [aggregated360Results, setAggregated360Results] = useState([])
  const [aggregated360Label, setAggregated360Label] = useState([])
  const [aggregated360Highest, setAggregated360Highest] = useState('')
  const { updateStartChartdataSelfchartdata, updateStartChartdata } = useGroupReportDate();

  const [allResultsState, setAllResultsState] = useState([]);

  const [dynamicData, setDynamicData] = useState([...initialData]);

  const displayData = dynamicData?.filter((el) => el.quadrant === highestStarter?.toUpperCase());
  const allVariableSets = [apiData?.variables];
  useEffect(() => {
    const avgPercentage = [
      averagePercentages?.find((el) => el?.name === "Strength")?.avg,
      averagePercentages?.find((el) => el?.name === "Heart")?.avg,
      averagePercentages?.find((el) => el?.name === "Soul")?.avg,
      averagePercentages?.find((el) => el?.name === "Mind")?.avg
    ]

    // All four tied: take the first quadrant in clockwise order
    const maxAvgObj = isFullTie(averagePercentages?.map((el) => el?.avg))
      ? applyFullTieOrder(averagePercentages, (el) => el?.name, (el) => el?.avg)[0]
      : averagePercentages?.reduce((max, current) => {
        return current.avg > max.avg ? current : max;
      });


    setSnapshotResults([
      Number(avgPercentage[0]?.toFixed(2)),
      Number(avgPercentage[1]?.toFixed(2)),
      Number(avgPercentage[2]?.toFixed(2)),
      Number(avgPercentage[3]?.toFixed(2))
    ]);

    setHighestStarter(maxAvgObj?.name?.toLowerCase());
    updateStartChartdata(avgPercentage || [0, 0, 0, 0]);
    setStarterLabel(['strength', 'heart', 'soul', 'mind']);

  }, [averagePercentages, apiData]);

  const quadrantScores = {
    "HEART": 1,
    "SOUL": 2,
    "MIND": 3,
    "STRENGTH": 4
  };

  useEffect(() => {
    const avgPercentage = [
      averagePercentagesSelf?.find((el) => el?.name === "Strength")?.avg,
      averagePercentagesSelf?.find((el) => el?.name === "Heart")?.avg,
      averagePercentagesSelf?.find((el) => el?.name === "Soul")?.avg,
      averagePercentagesSelf?.find((el) => el?.name === "Mind")?.avg
    ]

    setSnapshotResultsSelf([
      Number(avgPercentage[0]?.toFixed(2)),
      Number(avgPercentage[1]?.toFixed(2)),
      Number(avgPercentage[2]?.toFixed(2)),
      Number(avgPercentage[3]?.toFixed(2))
    ]);
    updateStartChartdataSelfchartdata(avgPercentage || [0, 0, 0, 0]);
    setStarterLabel(['strength', 'heart', 'soul', 'mind']);
  }, [averagePercentagesSelf]);


  useEffect(() => {
    if (!highestStarter || !groupReportCtx) return;

    const quadrantKey = quadrantScores[highestStarter.toUpperCase()];
    const tempResults = [];

    displayData?.forEach((el, index) => {
      const res = groupReportCtx?.calculateQuestionScore(
        quadrantKey,
        allVariableSets,
        index + 1,
        "in_focus"
      );

      if (res?.averageScore !== null && quadrantKey === quadrantScores[el.quadrant]) {
        tempResults.push({
          ...res,
          question: el.question
        });
      }
    });

    setAllResultsState(tempResults);
  }, [highestStarter, groupReportCtx, apiData]);


  const getStarterHeading = () => {
    if (highestStarter?.includes("heart")) return "HEART STARTER";
    if (highestStarter?.includes("str")) return "STRENGTH STARTER";
    if (highestStarter?.includes("soul")) return "SOUL STARTER";
    if (highestStarter?.includes("mind")) return "MIND STARTER";
    else return "NONE";
  }

  const getStarterSections = () => {
    if (highestStarter?.includes("heart")) return "Heart";
    if (highestStarter?.includes("str")) return "Strength";
    if (highestStarter?.includes("soul")) return "Soul";
    if (highestStarter?.includes("mind")) return "Mind";
    else return "";
  }

  const getStarterLogo = () => {
    if (highestStarter?.includes("heart")) return HeartIcon;
    if (highestStarter?.includes("str")) return StrengthIcon;
    if (highestStarter?.includes("soul")) return SoulIcon;
    if (highestStarter?.includes("mind")) return MindIcon;
    else return "NONE";
  }

  const HighestStarterInfo = () => {
    if (highestStarter?.includes("heart")) return "Heart Starters are connection-oriented people who lead with feelings, wants, passion, or desire. They are the lovers, encouragers, connectors, culture carriers, and relational catalysts who bring people together. They are motivated by belonging, which draws them into deeper relationships with themselves and others. Their “Capacity for Connection” is the lens through which everything passes."
    if (highestStarter?.includes("str")) return "Strength Starters are action-oriented people who bring energy as doers, drivers, and builders. They are the warriors, operators, executors, competitors, and mobilizers who move things forward. They are motivated by momentum, practicalities, and results. Their “Capacity for Service” drives them to carry weight for something bigger than themselves."
    if (highestStarter?.includes("soul")) return "Soul Starters are meaning-oriented people who offer wisdom, perspective, and creativity. They are the sages, storytellers, inventors, creators, and big-picture thinkers who look for what matters most. They are driven by story, symbolism, and purpose and consistently return to the deeper “why.” Their “Capacity for Meaning” shapes the way they connect, communicate, and move through the world."
    if (highestStarter?.includes("mind")) return "Mind Starters are logic-oriented people grounded in structure, strategy, and planning. They are the strategists, the thinkers, engineers, designers, and planners who bring order to complexity and spend much of their energy in thoughtful analysis. They are motivated by learning, understanding, and clarity. Their “Capacity for Understanding” shapes how they lead and decide."
    else return ""
  }

  const StarterInfo2 = () => {
    if (highestStarter?.includes("heart")) return "“Capacity for Connection” is their fundamental point for action."
    if (highestStarter?.includes("str")) return "They steward a “Capacity for Service” to something greater than themselves."
    if (highestStarter?.includes("soul")) return " “Capacity for Meaning” is their context for everything else."
    if (highestStarter?.includes("mind")) return "“Capacity for Understanding” the big picture is a necessity."
    else return "";
  }

  const QueOne = () => {
    if (highestStarter?.includes("heart")) return "How does this make me feel?"
    if (highestStarter?.includes("str")) return "How do I win?"
    if (highestStarter?.includes("soul")) return "Why are we doing this?"
    if (highestStarter?.includes("mind")) return "Does this make sense to me?"
    else return "";
  }
  const QueTwo = () => {
    if (highestStarter?.includes("heart")) return "Who needs my help?"
    if (highestStarter?.includes("str")) return "What needs to be done?"
    if (highestStarter?.includes("soul")) return "What's the deeper purpose here?"
    if (highestStarter?.includes("mind")) return "What do we need to know?"
    else return "";
  }
  const QueThree = () => {
    if (highestStarter?.includes("heart")) return "What do I need to stay connected?"
    if (highestStarter?.includes("str")) return "When can I get started?"
    if (highestStarter?.includes("soul")) return "Does this feel true to who I am?"
    if (highestStarter?.includes("mind")) return "What steps come next?"
    else return "";
  }

  const QueFour = () => {
    if (highestStarter?.includes("heart")) return null;
    if (highestStarter?.includes("str")) return null;
    if (highestStarter?.includes("soul")) return null
    if (highestStarter?.includes("mind")) return null;
    else return "";
  }

  const StrengthsSection = () => {
    if (highestStarter?.includes("heart")) return [
      { title: "Strong Connector", desc: "Build trust and rapport quickly." },
      { title: "Team Builder", desc: "Create a sense of belonging." },
      { title: "Empathy Radar", desc: "Read emotions accurately." },
      { title: "Culture Lifter", desc: "Improve team morale and cohesion." },
      { title: "Warm Communicator", desc: "Make people feel seen and valued." },
      { title: "People-Pleasing", desc: "Put others’ needs above your own mission." },
      { title: "Emotion Overload", desc: "Get overwhelmed by strong feelings." },
      { title: "Slow to Act", desc: "Reflect too long before moving forward." },
      { title: "Over-Carrying", desc: "Take on others’ emotional weight." },
      { title: "Easily Wounded", desc: "Feel hurt when relationships shift." },
    ];
    if (highestStarter?.includes("str")) return [
      { title: "Fast Executor", desc: "Turn ideas into action quickly." },
      { title: "Decisive Leader", desc: "Make quick, confident calls." },
      { title: "Results Driver", desc: "Push work to the finish line." },
      { title: "Resource Hunter", desc: "Get what the team needs to win." },
      { title: "High Ownership", desc: "Take responsibility for the mission." },
      { title: "Over-Driving", desc: "Push too hard or too fast." },
      { title: "Impulsive Action", desc: "Move before the plan is clear." },
      { title: "Relational Gaps", desc: "Miss emotional cues in people." },
      { title: "Takeover Tendencies", desc: "Do the work instead of delegating." },
      { title: "Burnout Risk", desc: "Carry more weight than is healthy." },
    ];
    if (highestStarter?.includes("soul")) return [
      { title: "Big-Picture Thinker", desc: "See long-term purpose and direction." },
      { title: "Creative Framer", desc: "Use stories and ideas to inspire others." },
      { title: "Wise Counselor", desc: "Offer insight during uncertainty." },
      { title: "Perspective Shifter", desc: "Help teams see new angles." },
      { title: "Vision Driver", desc: "Keep focus on mission and meaning." },
      { title: "Idea Island", desc: "Withdraw into thinking instead of acting." },
      { title: "Follow-Through Gaps", desc: "Struggle with details and routine tasks." },
      { title: "Idealism Drift", desc: "Expect standards that are hard to execute." },
      { title: "Avoiding Tension", desc: "Pull back from conflict or hard conversations." },
      { title: "Feeling Misunderstood", desc: "Retreat when insight isn’t recognized." },
    ];
    if (highestStarter?.includes("mind")) return [
      { title: "Clear Planner", desc: "Build structure, systems, and order." },
      { title: "Problem Solver", desc: "Break complex issues into steps." },
      { title: "Logical Thinker", desc: "Make steady, informed decisions." },
      { title: "Consistent Communicator", desc: "Provide clarity and direction." },
      { title: "Calm Under Pressure", desc: "Stay steady when things intensify." },
      { title: "Analysis Paralysis", desc: "Slow decisions while gathering more data." },
      { title: "Low Empathy Signals", desc: "Seem distant or critical." },
      { title: "Rigid Processes", desc: "Hold too tightly to one approach." },
      { title: "Detail Dumping", desc: "Overwhelm others with information." },
      { title: "Relational Blind Spots", desc: "Miss interpersonal dynamics." },
    ];
    else return "";
  }

  const ChallengesSection = () => {
    if (highestStarter?.includes("heart")) return null;
    if (highestStarter?.includes("str")) return null;
    if (highestStarter?.includes("soul")) return "Soul Starters may isolate themselves in the world of ideas, withdraw when they feel invalidated or misunderstood, or seek safety in exploration without choosing to act. Their natural insight can sometimes lead to pride or elitism, and they may become overly idealistic. They may avoid relationships that require a lot of work or create unnecessary anxiety and tension. Driven by vision, they often struggle with details and routine tasks, finding them challenging to follow through on."
    if (highestStarter?.includes("mind")) return null;
    else return "";
  }

  const combinedList = () => {
    if (!(highestStarter?.includes("str") || highestStarter?.includes("mind") || highestStarter?.includes("soul") || highestStarter?.includes("heart"))) return null;
    const items = StrengthsSection();
    if (!Array.isArray(items)) return null;
    return items;
  };

  return (
    <div className='self-report-result' style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />

      <div className="heart-starter-wrapper threesixty-starter-container-wraper">
        <div className="heart-starter-container">
          <h2 className="heart-starter-title" style={{padding:"13px 0px"}}>
            YOU TESTED AS A {highestStarter && getStarterHeading()} (360)
          </h2>

          <div className="heart-starter-content">
            <div className="heart-icon">
              <img src={getStarterLogo()} alt="Heart Icon" />
            </div>

            <div className="heart-description">
              {HighestStarterInfo()}
              {/* <br />
              {StarterInfo2()} */}
            </div>
          </div>

          <div className="heart-starter-details threesixty-starter-container" >
            <div className="">
              <h5 className="questions-title">{getStarterSections()} Starters often ask:</h5>
              <ol className="questions-list" style={{ marginBottom: "0px" }}>
                {[QueOne(), QueTwo(), QueThree()].filter(Boolean).map((q, idx) => (
                  <li key={idx}>{q}</li>
                ))}
              </ol>
            </div>

            <div className="strengths-challenges">
              <h5 className="section-title">Likely Strengths &amp; Potential Challenges</h5>
              {combinedList() ? (
                <ol className="section-list" >
                  {combinedList()?.map((item, idx) => (
                    <li key={idx}>
                      <input type='checkbox' disabled />
                      <strong>{item.title}</strong> &ndash; {item.desc}
                    </li>
                  ))}
                </ol>
              ) : (
                <ol className="section-list">
                  {StrengthsSection() && (
                    <li>
                      <strong>Strengths:</strong> {StrengthsSection()}
                    </li>
                  )}
                  {ChallengesSection() && (
                    <li>
                      <strong>Challenges:</strong> {ChallengesSection()}
                    </li>
                  )}
                </ol>
              )}
            </div>
          </div>
        </div>

        <h3 style={{ fontSize: '11px', marginTop: 0, marginBottom: "13px", fontWeight: 700, fontFamily: "Helvetica, sans-serif", lineHeight: "15px", letterSpacing: "0px", color: '#00577D' }} >STARTER QUADRANT OVERVIEW CHART</h3>

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', justifyContent: "space-between", }}>


          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',

          }}>
            <span style={{
              fontWeight: '700',
              marginBottom: '2px',
              color: '#00577D',
              fontSize: '10px',
              lineHeight: "14px",
              fontFamily: 'Helvetica'
            }}>SELF</span>
            <div style={{ transform: 'scale(1)', transformOrigin: 'center' }} >
              <StarterChart360
                // originalData={[10,20,30,20]}
                originalData={snapshotResultSelf}
                labels={starterLabel}
                ch='mind'
                position="center"
              />
            </div>
          </div>
          <div style={{ borderLeft: '1px solid rgb(0,0,0)', height: '115px', alignSelf: 'center', marginTop: '18px' }} />
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <span style={{
              fontWeight: '700',
              marginBottom: '2px',
              color: '#00577D',
              fontSize: '10px',
              lineHeight: "14px",
              fontFamily: 'Helvetica'
            }}>360</span>
            <div style={{ transform: 'scale(1)', transformOrigin: 'center' }} >
              <StarterChart360
                originalData={snapshotResult}
                labels={starterLabel}
                ch='mind'
                position="center"
              />
            </div>
          </div>
        </div>

        <div style={{ marginTop: '13px', textAlign: 'center' }}>
          <p style={{ margin: 0, fontWeight: "400", fontSize: "8px", lineHeight: '12px', color: 'rgb(0, 87, 125)' }}>
            These charts reflect both your own results and the combined results calculated with all the observer scores (excluding yours). The highest result is your starter quadrant. We will reflect more on your flow into the other quadrants in the next section.
          </p>
        </div>
      </div>


      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}
